<template>
  <u-animate-container class="wrap">
    <u-animate
      class="title_en"
      name="fadeInDown"
      delay="0s"
      duration="1s"
      :iteration="1"
      :offset="0"
      animateClass="animated"
      :begin="true"
    >
      {{ title_en }}
    </u-animate>
    <u-animate
      class="title_cn"
      name="fadeInDown"
      delay="0s"
      duration="1s"
      :iteration="1"
      :offset="0"
      animateClass="animated"
      :begin="true"
    >
      {{ title_cn }}
    </u-animate>
  </u-animate-container>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
export default {
  components: {
    UAnimateContainer,
    UAnimate
  },
  data() {
    return {
      title_en: "",
      title_cn: ""
    };
  },
  mounted() {
    this.title_en = this.en;
    this.title_cn = this.cn;
  },
  methods: {},
  props: ["en", "cn"]
};
</script>

<style scoped lang="scss">
.wrap {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: absolute;
  top: 55%;
  z-index: 9;
}
.title_en {
  font-size: 0.16rem;
  text-align: center;
  color: #fd8204;
}
.title_cn {
  font-size: 0.7rem;
  text-align: center;
  margin-top: 15px;
  color: #fff;
  font-weight: bold;
}
.title_line {
  background: #ff5e17;
  height: 2px;
  width: 60px;
  display: block;
  margin: 45px auto;
}
@media screen and (max-width: 750px) {
  .title_en {
    font-size: 0.5rem;
  }
  .title_cn {
    font-size: 1.2rem;
    line-height: 1.5;
    font-weight: bold;
    margin-bottom: 1rem;
    margin-top: 5px;
  }
  .title_line {
    display: none;
  }
  .product_wrap {
    .wrap {
      .title_en {
        margin-top: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/Common/TitleWhite.vue